import { IKnmListByPlanFilter } from '../interfaces/IKnmListByPlanFilter';

export const initialKnmListByPlanFilter: IKnmListByPlanFilter = {
  name: '',
  riskCategory: [],
  reasonDateBetweenStart: '',
  reasonDateBetweenEnd: '',
  mspCategory: [],
  supervisionType: undefined,
  objectsType: undefined,
  objectsKind: undefined,
  objectsSubKind: undefined,
  isHasRequirements: undefined,
  isHasApproveDocs: undefined,
  startDateBetweenStart: '',
  startDateBetweenEnd: '',
  kinds: undefined,
  events: [],
  isHasCollaboratingOrganization: undefined,
};
